// @ts-nocheck
import { createRouter, createWebHashHistory } from 'vue-router';
import { createPageGuard } from './guard';
export const LayoutChildren = [
  {
    path: 'home',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '首页',
    },
  },
  {
    path: 'customer-score-result',
    name: 'customer-score-result',
    component: () => import('@/views/scoreResult/index.vue'),
    meta: {
      title: '首页 / 计算结果 / 客户得分结果',
    },
  },
  {
    path: 'risk-evaluation',
    name: 'risk-evaluation',
    component: () => import('@/views/riskEvaluation/index.vue'),
    meta: {
      title: '首页 / 计算结果 / 客户风险分析',
    },
  },
  {
    path: 'dealer-appeal-report',
    name: 'dealer-appeal-report',
    component: () => import('@/views/dealerAppeal/index.vue'),
    meta: {
      title: '首页 / 计算结果 / 经销商申诉核查报告',
    },
  },
  {
    path: 'appeal-detail-result',
    name: 'appeal-detail-result',
    component: () => import('@/views/detailedResult/index.vue'),
    meta: {
      title: '首页 / 计算结果 / 申诉明细结果',
    },
  },
  {
    path: 'penalty-notice-letter',
    name: 'penalty-notice-letter',
    component: () => import('@/views/noticeLetter/index.vue'),
    meta: {
      title: '首页 / 处罚通知函',
    },
  },
  {
    path: 'data-export-records',
    name: 'data-export-records',
    component: () => import('@/views/exportRecords/index.vue'),
    meta: {
      title: '首页 / 数据导出记录',
    },
  },
];
export const RootRoute = {
  path: '/',
  name: 'root',
  redirect: '/login', // 这里应该是绝对路径
};
export const LoginRoute = {
  path: '/login',
  name: 'login',
  component: () => import('@/views/login/index.vue'),
  meta: {
    title: '登录',
  },
};
export const LayoutRoute = {
  path: '/layout',
  name: 'layout',
  component: () => import('@/views/layout/index.vue'),
  children: LayoutChildren,
};
export function setupGuard() {
  createPageGuard(router);
}
const basicRoutes = [RootRoute, LoginRoute, LayoutRoute];
export const router = createRouter({
  history: createWebHashHistory(),
  routes: basicRoutes,
});
//# sourceMappingURL=index.js.map
